
import React, { useEffect, useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import TotalPartner from "../../../Components/PartnerAdminDashboardComp/PartnerAdminDash/TotalPartner"
import PartnerClientTable from "../../../Components/PartnerAdminDashboardComp/PartnerAdminDash/PartnerClientTable";
import BarGraph from "../../../Components/PartnerAdminDashboardComp/PartnerAdminDash/BarGraph";
import SolidgurageGraph from "../../../Components/PartnerAdminDashboardComp/PartnerAdminDash/SolidgurageGraph";
import { toast } from "react-toastify";
import { partner_Admin } from "../../../Configuration/Partner_URL";
import { decryptData } from "../../../CommonMethhods/CommonMethods";
import { axiosSsoText } from "../../../CommonMethhods/axiosPartnerInterceptor";


function PartnerAdminDashboard() {
  const storeToken = localStorage.getItem("ssoToken");
  const [statsData, setStatsData] = useState("");
  
  if(storeToken == null){
    window.location.replace("/");
  }

  const getStatsData = async () => {
    try {
      const getValues = await axiosSsoText.get(
        partner_Admin.GetStatsData_URL,
      );
      const statsVal = decryptData(getValues?.data);
      let decryptedStatsVal = JSON.parse(statsVal);
      if (decryptedStatsVal?.status === 0) {
        setStatsData(decryptedStatsVal?.data);
      }
      else if (decryptedStatsVal?.status === 1) {
        toast.error(decryptedStatsVal?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getStatsData();
  }, []);


  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="partner-adminPage">
          <TotalPartner
            statsData={statsData}
          />
          {/* <PartnerClientGraph /> */}

          <div className='card-box bottom-25 graph-bar row'>
            <div className="col-12 col-md-12 ">
              <BarGraph />
              {/* <SolidgurageGraph title={"500"} 
      statsData={statsData}/> */}
            </div>
          </div>
          <PartnerClientTable />


        </div>
      </main>
    </>
  );
}

export default PartnerAdminDashboard;
